import { DomainData } from "./domain-data";

export type Type = 'FIS' | 'GIU';

export function isFisical(type: Type): boolean {
    return type == 'FIS';
}

export function isGiuridical(type: Type): boolean {
    return type == 'GIU';
}

class NdgInsertFields {
    type: DomainData[] = [
        {key: 'FIS', value: 'ndg.type-fis'},
        {key: 'GIU', value: 'ndg.type-giu'}
    ];

    employees: DomainData[] = [
        {key: 'AD1', value: 'ndg.employees.AD1'},
        {key: 'AD2', value: 'ndg.employees.AD2'},
        {key: 'AD3', value: 'ndg.employees.AD3'}
    ]
}

export const ndgInsertFields = new NdgInsertFields();